import {ProjectEntity} from "@/pb/api/devplan/types/documents";
import {bugPath, documentPath, projectPath, quickWinPath} from "@/app/paths";

export const projectKindQuickWin = 'quick-win' as const;
export const projectKindIdea = 'idea' as const;
export const projectKindBug = 'bug' as const;
export const projectKindInferred = 'inferred' as const;

export type ProjectsArchiveFilter = "active" | "all" | "archived";

export interface ProjectsFilter {
  kind?: string,
  // When true, include all project types (ideas, quick wins, and regular projects)
  // When false or undefined, exclude projects with a kind when no kind filter is specified
  includeAll?: boolean,
}

/**
 * Returns the canonical href for a project based on its kind.
 * - Ideas navigate to their discovery document when one exists, otherwise the project page.
 * - Quick wins navigate to their quick-win view.
 * - All others navigate to the standard project page.
 */
export function getProjectHref(
  companyId: number,
  projectId: string,
  kind: string | undefined,
  discoveryDocId: string | undefined,
): string {
  if (kind === projectKindIdea) {
    if (discoveryDocId) return documentPath(companyId, discoveryDocId);
    return projectPath(companyId, projectId);
  }
  if (kind === projectKindQuickWin) return quickWinPath(companyId, projectId);
  if (kind === projectKindBug) return bugPath(companyId, projectId);
  return projectPath(companyId, projectId);
}

export function isProjectFilterMatch(project: ProjectEntity, filter?: ProjectsFilter): boolean {
  if (filter?.kind && filter.kind !== project.kind) {
    return false
  }
  // When includeAll is true, include all projects regardless of kind
  if (filter?.includeAll) {
    return true
  }
  // When no filter is specified and includeAll is not true, exclude ideas and other special kinds (only show regular projects)
  if (!filter?.kind && !filter?.includeAll && project.kind && project.kind.length > 0) {
    return false
  }
  return true
}
